import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../../Router/all_routes";
import Swal from "sweetalert2";
import { api_post } from "../../../helpers/index";

const AddRank = () => {
  const route = all_routes;
  const navigate = useNavigate();

  // State for form fields
  const [name, setName] = useState("");
  const [rankSequence, setRankSequence] = useState("");
  const [eligibleCreditFrom, setEligibleCreditFrom] = useState("");
  const [eligibleCreditTo, setEligibleCreditTo] = useState("");
  const [errors, setErrors] = useState({});

  // Validate input fields
  const validateInputs = () => {
    const newErrors = {};
    if (!name.trim()) newErrors.name = "Name is required.";
    if (!rankSequence) newErrors.rankSequence = "Rank Sequence is required.";
    if (!eligibleCreditFrom) newErrors.eligibleCreditFrom = "Eligible Credit From is required.";
    if (!eligibleCreditTo) newErrors.eligibleCreditTo = "Eligible Credit To is required.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle saving the rank
  const handleSaveRank = async () => {
    if (!validateInputs()) {
      return;
    }

    const body = {
      name: name,
      rank_sequence: rankSequence,
      eligible_credit_from: eligibleCreditFrom,
      eligible_credit_to: eligibleCreditTo,
    };

    try {
      const result = await api_post("rank/create", body);
      if (result.status === 1) {
        // Show success message with SweetAlert2
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Rank created successfully!",
        }).then(() => {
          // Close the modal using vanilla JavaScript
          const modalElement = document.getElementById('add-units-category');
          if (modalElement) {
            // Remove modal-open class from body
            document.body.classList.remove('modal-open');
            // Remove modal backdrop
            const backdrop = document.querySelector('.modal-backdrop');
            if (backdrop) {
              backdrop.parentNode.removeChild(backdrop);
            }
            // Hide modal
            modalElement.style.display = 'none';
            modalElement.classList.remove('show');
            modalElement.setAttribute('aria-hidden', 'true');
            modalElement.removeAttribute('aria-modal');
          }
          
          // Refresh the page
          window.location.reload();
        });
      } else {
        // Show error message with SweetAlert2
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to create rank. Please try again later.",
        });
      }
    } catch (error) {
      console.error("Error creating rank:", error);
    }
  };

  return (
    <>
      {/* Add Rank */}
      <div className="modal fade" id="add-units-category">
        <div className="modal-dialog modal-dialog-centered custom-modal-two">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>Add New Rank</h4>
                  </div>
                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body custom-modal-body">
                  <div className="mb-3">
                    <label className="form-label">Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                    {errors.name && <div className="text-danger mt-1">{errors.name}</div>}
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Rank Sequence</label>
                    <input
                      type="number"
                      className="form-control"
                      value={rankSequence}
                      onChange={(e) => setRankSequence(e.target.value)}
                    />
                    {errors.rankSequence && <div className="text-danger mt-1">{errors.rankSequence}</div>}
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Eligible Credit From</label>
                    <input
                      type="number"
                      className="form-control"
                      value={eligibleCreditFrom}
                      onChange={(e) => setEligibleCreditFrom(e.target.value)}
                    />
                    {errors.eligibleCreditFrom && <div className="text-danger mt-1">{errors.eligibleCreditFrom}</div>}
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Eligible Credit To</label>
                    <input
                      type="number"
                      className="form-control"
                      value={eligibleCreditTo}
                      onChange={(e) => setEligibleCreditTo(e.target.value)}
                    />
                    {errors.eligibleCreditTo && <div className="text-danger mt-1">{errors.eligibleCreditTo}</div>}
                  </div>
                  <div className="modal-footer-btn">
                    <Link
                      to="#"
                      className="btn btn-cancel me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <button
                      type="button"
                      className="btn btn-submit"
                      onClick={handleSaveRank}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Rank */}
    </>
  );
};

export default AddRank;